// Sainik School Kunjpura crest — used in place of the 🌹 rose emoji across the Kunjeans
// pillar (nav labels, headings, and the "no photo yet" card placeholder), so the pillar's
// branding is the school's own mark rather than a generic flower emoji.
export const KUNJEAN_CREST_URL = 'https://firebasestorage.googleapis.com/v0/b/shreyaadieducation-prod.firebasestorage.app/o/kunjean-photos%2Fsite-assets%2Fssk-crest.png?alt=media';
